export const INTERNAL_DOMAIN = 'bo.wix.com';
export const boAuthMiddleware = (boAuth) => (req, res, next) => {
  if (req.headers.host === INTERNAL_DOMAIN) {
    if (req.isApiCall) {
      boAuth.forbid()(req, res, next);
    } else {
      boAuth.redirect()(req, res, next);
    }
  } else {
    next();
  }
};
